import { isEmpty } from 'ramda'
import { useEffect, useState } from 'react'

/**
 * hook to search by string in a arrays of objects
 *
 * @param {string} initialQuery initial query value
 * @param {object} data The data to search
 * @param {object} onFormat If necessary, it is to format the new data results.
 */
const useSearch = (
    initialQuery = '',
    data = [],
    onFormat,
    searchFields = [],
    setRowsSize,
) => {
    const [query, setQuery] = useState(initialQuery)
    const [results, setResults] = useState([])

    useEffect(() => {
        if (!isEmpty(query) || data.length > 0) {
            handleSearchQuery()
        }
    }, [data, query])

    const handleSearchQuery = () => {
        const trimmedQuery = query.trim()
        if (!isEmpty(trimmedQuery)) {
            let newResults = []
            try {
                newResults =
                    data?.filter(item => {
                        let hasMatch = false
                        for (let key of searchFields) {
                            const hasValidType =
                                typeof item[key] === 'string' ||
                                typeof item[key] === 'number'
                            if (hasValidType) {
                                hasMatch = item[key]
                                    ?.toString()
                                    ?.toLowerCase()
                                    ?.includes(trimmedQuery?.toLowerCase())
                                if (hasMatch) {
                                    break
                                }
                            }
                        }
                        return hasMatch
                    }) || []
            } catch (error) {
                console.error('Error filtering data:', error)
            }

            const formattedResults = onFormat
                ? onFormat(newResults)
                : newResults

            if (setRowsSize) {
                setRowsSize(formattedResults?.length || 0)
            }
            setResults(formattedResults || [])
        } else {
            const formattedResults = onFormat ? onFormat(data) : data

            if (setRowsSize) {
                setRowsSize(formattedResults?.length || 0)
            }
            setResults(formattedResults || [])
        }
    }

    return {
        query,
        setQuery,
        results,
        setResults,
        handleSearchQuery,
    }
}

export default useSearch
